import { render, staticRenderFns } from "./tp-comment.vue?vue&type=template&id=2ec2315d&scoped=true"
import script from "./tp-comment.vue?vue&type=script&lang=js"
export * from "./tp-comment.vue?vue&type=script&lang=js"
import style0 from "./tp-comment.vue?vue&type=style&index=0&id=2ec2315d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec2315d",
  null
  
)

export default component.exports